import { useEffect, useState } from "react";

const useDebounce = () => {

  const [timeOutId, setTimeOutId] = useState<any>();
  
  useEffect(() => {
    return () => clearTimeout(timeOutId);
  }, [timeOutId]);
  

  const onDebounce = (callback:any) => {
    let timer = setTimeout(() => {
      callback()
    }, 2000);
    setTimeOutId(timer);
  };

  return onDebounce;
};
export default useDebounce;
